import { type FileExtEnum } from "@finway-group/shared/lib/models"
import * as path from "path"

const extractFileExtension = (fileUrl: string | undefined) => (!fileUrl ? undefined : path.extname(new URL(fileUrl).pathname).toLowerCase())

export const isFileExtensionMatching = (fileUrl: string | undefined, fileExtension: FileExtEnum) => extractFileExtension(fileUrl) === fileExtension

export const isFileExtensionAllowed = (fileName: string, allowList: ReadonlyArray<string>) => allowList.some((allowedExt) => fileName.toLocaleLowerCase().endsWith(allowedExt))
